export class CalendarSettingsField {
    constructor(name, component, label, items) {
        this.name = name;
        this.component = component;
        this.props = {label, items};
    }

    static createCheckbox(name, label) {
        return new CalendarSettingsField(name, 'v-checkbox', label);
    }

    static createSelection(name, label, itemDefinitions) {
        const items = itemDefinitions.map(item => ({value: item.name, text: item.translation}));
        return new CalendarSettingsField(name, 'v-autocomplete-custom', label, items);
    }
}
